import { ListItem } from '@general';

import text from './glossary.json';

import styles from './glossary.module.scss';

export const Glossary = () => {
	return (
		<>
			<div className={styles.container}>
				{text.map((textItem: { term: string; definition: string }) => (
					<ListItem key={textItem.term} title={textItem.term} content={textItem.definition} />
				))}
			</div>
		</>
	);
};
